<div class="Heading">
  <div class="HeadingText">
    <div class="Title">{title}</div>
    <div class="Text">{subtitle}</div>
  </div>

  <div>
    <button class="aBtn atDark asLarge asIcon PinButton" data-icon="play_for_work" data-icon-rotate="90"
            on:click={() => minimized = true}></button>
  </div>
</div>

{#if before}
  <svelte:component this={before} maximized="{true}"/>
{/if}

<div class="Menu">
  {#each menu as item}
    <Item {item} />
  {/each}
  <slot name="after" />
</div>

<script>
  import Item from './NavigationMaximizedLevel1MenuItem.svelte';

  export let title = '';
  export let subtitle = '';
  export let menu;
  export let minimized;
  export let before;
</script>


<style lang="stylus">
  @import './styles.blocks.styl'

  .Heading {
    {Heading}
  }

  .HeadingText {
    {HeadingText}
  }

  .Title {
    {Title}
  }

  .Text {
    {Text}
  }

  .PinButton {
    {PinButton}
  }

  .Menu {
    {Menu}
  }
</style>
